import { useState } from 'react';
import { Grid2 } from '@mui/material';
import { getActualStatus } from '../../_helpers/auction.helper';
import { useAuctionUserAdmin } from '../../_hubs/auctionUserAdmin.hub';
import { CatalogueItemStatusCard } from './components/auction-catalogueItemStatusCard';
import { AuctionCatalogueItemView } from './components/auction-catalogueItemView';
import { AuctionCatalogueList } from './components/auction-catalogueList';
import { AuctionChat } from './components/auction-chat';
import CountdownCard, { CountdownControls } from './components/auction-countDownCard';
import { AuctionMessages } from './components/auction-messages';
import { AuctionCatalogueItemAdminUserBid } from './components/auction-catalogueItemAdminUserBid';
import { AuctionUserList } from './components/auction-userList';
import { AuctioncatalogueItemUserBids } from './components/auction-catalogueItemBids';
import { AuctionLogIndex } from '../auctionLog/auctionLog-index';

export function AuctionAdminIndex(params: {
    auction: any,
    catalogueItem: any,
    catalogueItemLoading: boolean
}) {
    const { onlineUsers, heartbeats, tabVisibleByUserId } = useAuctionUserAdmin();

    const [defaultSecondsLeft, setDefaultSecondsLeft] = useState(30);
    const [secondsLeft, setSecondsLeft] = useState(30);

    return (
        <>
            <Grid2 size={{ xs: 12, md: 4 }} sx={{ minWidth: 0 }}>
                <Grid2 container spacing={1}>
                    <Grid2 size={{ xs: 12 }}>
                        <AuctionCatalogueList auction={params.auction} catalogueItem={params.catalogueItem} actualAuctionStatusId={getActualStatus(params.auction, params.catalogueItem)} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <AuctionChat auctionId={params.auction.id} catalogueId={params.catalogueItem?.catalogueId} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <AuctionMessages catalogueId={params.catalogueItem?.catalogueId} />
                    </Grid2>
                </Grid2>
            </Grid2>

            <Grid2 size={{ xs: 12, md: 8 }} sx={{ minWidth: 0 }}>
                <Grid2 container spacing={1}>
                    <Grid2 size={{ xs: 12 }}>
                        <CatalogueItemStatusCard catalogueItem={params.catalogueItem} actualAuctionStatusId={getActualStatus(params.auction, params.catalogueItem)} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }}>
                        <CountdownControls
                            auctionId={params.auction.id}
                            catalogueItem={params.catalogueItem}
                            actualAuctionStatusId={getActualStatus(params.auction, params.catalogueItem)}
                            onlineUsers={onlineUsers}
                            defaultSecondsLeft={defaultSecondsLeft}
                            onRestart={() => setSecondsLeft(defaultSecondsLeft)}
                        />
                    </Grid2>
                    <Grid2 size={{ xs: 9 }} sx={{ minWidth: 0 }}>
                        <Grid2 container spacing={1}>
                            <Grid2 size={{ xs: 12 }}>
                                <CountdownCard
                                    actualAuctionStatusId={getActualStatus(params.auction, params.catalogueItem)}
                                    secondsLeft={secondsLeft}
                                    setSecondsLeft={setSecondsLeft}
                                    defaultSecondsLeft={defaultSecondsLeft}
                                    setDefaultSecondsLeft={setDefaultSecondsLeft}
                                />
                            </Grid2>
                            <Grid2 size={{ xs: 12 }}>
                                <AuctionCatalogueItemView catalogueItem={params.catalogueItem} catalogueItemLoading={params.catalogueItemLoading} />
                            </Grid2>
                            <Grid2 size={{ xs: 12 }}>
                                <AuctionCatalogueItemAdminUserBid catalogueItem={params.catalogueItem} auctionId={params.auction?.id} actualAuctionStatusId={getActualStatus(params.auction, params.catalogueItem)} catalogueItemLoading={params.catalogueItemLoading} />
                            </Grid2>
                        </Grid2>
                    </Grid2>
                    <Grid2 size={{ xs: 3 }} sx={{ minWidth: 0 }}>
                        <AuctionUserList onlineUsers={onlineUsers} catalogueId={params.catalogueItem?.catalogueId} auctionId={params.auction?.id} lastSeenByUserId={heartbeats} tabVisibleByUserId={tabVisibleByUserId} />
                    </Grid2>
                    <Grid2 size={{ xs: 12 }} sx={{ minWidth: 0 }}>
                        <AuctioncatalogueItemUserBids catalogueItem={params.catalogueItem} onlineUsers={onlineUsers} actualAuctionStatusId={getActualStatus(params.auction, params.catalogueItem)} />
                    </Grid2>
                    {(!!params.auction && !!params.catalogueItem) && (
                        <Grid2 size={{ xs: 12 }}>
                            <AuctionLogIndex />
                        </Grid2>
                    )}
                </Grid2>
            </Grid2>
        </>
    );
}
